import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { Observable, map } from 'rxjs';
import { Announcement, AnnouncementArchive } from '../models';

@Injectable({
	providedIn: 'root'
})
export class AnnouncementService {

	announcementsTempData: Announcement[];

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private http: HttpClient,
		private utilsService: UtilsService
	) {
	}


	getAnnouncement(id: string): Observable<Announcement> {
		const url = `${this.appConfig.apiEndpoint}/v2/Announcement/${id}`;
		return this.http.get<Announcement>(url)
			.pipe(map(this.utilsService.handleResponse));
	}

	getAnnouncementsByPage(pageSize: number, pageNumber: number): Observable<Announcement[]> {
		const url = `${this.appConfig.apiEndpoint}/v2/Announcement/Archive?pageNumber=${pageNumber}&pageSize=${pageSize}`;
		return this.http.get<any>(url)
			.pipe(map(
				res => res['data']
			));
	}

	getAnnouncements(): Observable<Announcement[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/announcements`;
		return this.http.get<Announcement[]>(url)
			.pipe(
				map(response => {
					this.announcementsTempData = response['data'];
					return response['data'] || []
				})
			);
	}

	getArchives(): Observable<AnnouncementArchive[]> {
		const url = `${this.appConfig.apiEndpoint}/v2/Announcement/Archived`;
		return this.http.get<AnnouncementArchive[]>(url)
			.pipe(map(this.utilsService.handleResponse));
	}
}
